// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.orange-small-text[data-v-2a8dbf8c] {\n  color: var(--brand);\n  font-size: 2rem;\n  text-align: center;\n  font-weight: bold;\n  padding: 0.5rem 1rem;\n  min-height: 4rem;\n  white-space: nowrap;\n}\n.details-block[data-v-2a8dbf8c] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
